import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=18849dc0&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=18849dc0&lang=scss&scoped=true"
import style1 from "./PieChart.vue?vue&type=style&index=1&id=18849dc0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18849dc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18849dc0')) {
      api.createRecord('18849dc0', component.options)
    } else {
      api.reload('18849dc0', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=18849dc0&scoped=true", function () {
      api.rerender('18849dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/dashboardContainer/src/panels/PieChart.vue"
export default component.exports